/** The Future register's row rules (TMMAPP-0101): which rows it lists and which a writer can act on. */
import type { RegisterRow } from '@/api/projections';

/** The rows the card lists: what moves the running balance (the opening row is the "today" line). */
export function futureRows(register: readonly RegisterRow[]): RegisterRow[] {
  return register.filter((row) => row.kind === 'SLICE' || row.kind === 'PLANNED_EXPENSE');
}

/** A writer can dismiss or restore a row only through a plan line or a series it names. */
export function isActionable(row: RegisterRow): boolean {
  if (row.kind === 'PLANNED_EXPENSE') return row.planLineId !== null;
  return row.seriesId !== null && row.originalOn !== null && row.sliceRef !== null;
}

const SKIPPED = new Set(['CANCELLED', 'SUPERSEDED']);
export const isSkipped = (row: RegisterRow) => row.state !== null && SKIPPED.has(row.state);

/** What a dismiss or restore of this row acts on; the busy marker and the React key share it. */
export const actionKey = (row: RegisterRow) =>
  `${row.kind}|${row.planLineId ?? row.sliceRef ?? row.seriesId ?? 'x'}|${row.originalOn ?? row.occursOn ?? row.date}`;
